export const diplayCreditCard = (card)=>{
    return `${card.brand} - xxxx ${card.last4} - ${card.exp_month}/${card.exp_year}`
}